/* AdminPageTable auto-generated by npm run generator */
import { Link, makeStyles, Table, TableBody, TableCell, TableContainer, TableRow, Theme, Typography } from "@material-ui/core"
import MoreVert from "@material-ui/icons/MoreVert"
import clsx from "clsx"
import PortalTableHead from "components/atoms/PortalTableHead"
import { useCollectionSubscribe } from "hooks/useSnapshots"
import { observer } from "mobx-react"
import React, { CSSProperties } from "react"
import { Link as RouterLink, useHistory } from "react-router-dom"
import { PATHS } from "Router"
import Store from "store/Store"
import { useFilterMenu } from "./dropdowns/FilterMenu"
import OrgMenu from "./dropdowns/OrgMenu"
interface AdminPageTableProps {
    className?: string
    style?: CSSProperties
    children?: React.ReactNode
}

const useStyles = makeStyles((theme: Theme) => ({
    adminPageTableMolecule: {
        border: `1px solid ${theme.palette.secondary.main}`,
        padding: theme.spacing(4),
        display: "grid",
        gridGap: theme.spacing(4),
    },

    row: {
        cursor: "pointer",
    },
    noOrgs: {
        marginTop: theme.spacing(3),
        textAlign: "center",
        display: "grid",
        gridGap: theme.spacing(2),
    },
}))

const AdminPageTable: React.FC<AdminPageTableProps> = (props) => {
    const history = useHistory()
    const classes = useStyles()
    const className = clsx(classes.adminPageTableMolecule, props.className)
    const headers = ["Organization", "Created On", "Location", "Active Clinicians", "Active Clients", "status", <MoreVert />]
    const orgs = useCollectionSubscribe(Store.auth.orgCollection)
    const { FilterMenu, filteredUsers } = useFilterMenu(orgs)

    return (
        <div className={className} style={props.style}>
            <FilterMenu />
            <TableContainer>
                <Table>
                    <PortalTableHead headers={headers} />
                    <TableBody>
                        {filteredUsers?.map((org, i) =>
                            org ? (
                                <TableRow key={org.id} hover onClick={() => history.push(PATHS.ORG(org))} className={classes.row}>
                                    <TableCell>
                                        {/* PointerEvents set to none to stop propagation but link is still here for tabbing and a11y */}
                                        <Link component={RouterLink} to={PATHS.ORG(org)} style={{ pointerEvents: "none" }}>
                                            {org.orgName}
                                        </Link>
                                    </TableCell>
                                    <TableCell>{org.createdOn.toDate().toLocaleDateString()}</TableCell>
                                    <TableCell>
                                        {org.city}, {org.state}
                                    </TableCell>
                                    <TableCell>{org.clinicians.length}</TableCell>
                                    <TableCell>{org.clients.length}</TableCell>
                                    <TableCell>{org.status}</TableCell>
                                    <TableCell>
                                        <OrgMenu orgId={org.id} status={org.status} />
                                    </TableCell>
                                </TableRow>
                            ) : null
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {!orgs && (
                <div className={classes.noOrgs}>
                    <Typography variant="h5">You have no organizations.</Typography>
                    <Typography>After you create an organization, you will see the name appear here.</Typography>
                </div>
            )}
        </div>
    )
}

export default observer(AdminPageTable)
